import { render } from "./ResolveFacebookPage.vue?vue&type=template&id=3c8fcf5f&scoped=true"
import script from "./ResolveFacebookPage.vue?vue&type=script&lang=js"
export * from "./ResolveFacebookPage.vue?vue&type=script&lang=js"

import "./ResolveFacebookPage.vue?vue&type=style&index=0&id=3c8fcf5f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8fcf5f"]])

export default __exports__